/**
 * 需求来源：docs/ODM页面修改/AI提示词.md、docs/ODM页面修改/ODM.html
 * 注意事项：
 * 1. /odm 仍然是纯展示页，只返回 SEO 和 CDN_HOST。
 * 2. 改版后 SEO 文案同步到 Basic 与 Premium Advanced ODM 的新定位。
 *
 * @param {Object} ctx - SSR 直传 Koa ctx 或 ssrDataLoader 统一上下文
 * @param {Function} request - 统一请求函数（本页面未使用）
 * @returns {Object} 页面初始化数据，包含 __seo 和 cdnHost 字段
 */
async function fetchData(ctx, request) {
  let cdnHost = '';
  // 获取 Egg.js 原始上下文：SSR 框架直传原始 ctx（ctx.app 存在）或统一上下文包装（ctx.ctx）
  const eggCtx = (ctx && ctx.app) ? ctx : (ctx && ctx.ctx);
  if (eggCtx && eggCtx.app && eggCtx.app.config) {
    const viewVar = eggCtx.app.config.view && eggCtx.app.config.view.variable;
    cdnHost = (viewVar && viewVar.CDN_HOST) || '';
  }
  // CSR fallback: 从 layout 模板注入的全局变量获取
  if (!cdnHost && typeof CDN_HOST !== 'undefined') {
    cdnHost = CDN_HOST;
  }
  return {
    cdnHost: cdnHost,
    __seo: {
      title: 'CJdropshipping ODM Service | Basic & Premium Advanced ODM Solutions',
      keywords:
        'CJdropshipping ODM service,basic odm,premium advanced odm,custom products,branding,custom packaging,sourcing service',
      description:
        'Explore CJdropshipping Basic ODM and Premium Advanced ODM solutions for custom products, sourcing, branding, packaging, and launch-ready product development.',
    },
  };
}

module.exports = fetchData;
